import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { TagResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxTagService {
  constructor(
    private tagResourceService: TagResourceService,
  ) {
  }

  getTags(containerClass: string): Promise<string[]> {
    return firstValueFrom(this.tagResourceService.findByContainerClass(containerClass));
  }

  saveTags(containerClass: string, tags: string[]): Promise<string[]> {
    return firstValueFrom(this.tagResourceService.saveTags(containerClass, {tags}));
  }
}
